module.exports = __webpack_public_path__ + "Contribution Processing Instructions (Small Groups).pdf";